//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../axios/axios.js'
import { convertTime } from '../../components/helpers.js'
import { mapGetters } from 'vuex'
import Table from '../../components/Table/Table.vue'

function formatTime (value) {
  if (value !== null) {
    return convertTime(value)
  } else {
    return 'Нет данных'
  }
}

export default {
  components: {
    Table
  },
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      complexHistoryLocal: [],
      fullComplexHistory: [],
      displayButton: false,
      fullComplexHistoryDisplayed: false,
      loadingFullComplexHistory: false,
      pagination: {
        rowsPerPage: 25,
        page: 1
      },
      columns: this.getColumns(),
      userIds: {}
    }
  },
  computed: {
    ...mapGetters({
      taskStatesColors: 'getTaskStatesColors'
    })
  },
  watch: {
    'request.complexHistory': function (result) {
      if (result && result.length) {
        this.complexHistoryLocal = result
      } else {
        this.complexHistoryLocal = []
      }

      this.fullComplexHistoryDisplayed = false

      this.updateFullComplexHistory()
    }
  },
  created: function () {
    if (this.request && this.request.complexHistory) {
      this.pagination.page = Math.ceil(this.request.complexHistory.length / this.pagination.rowsPerPage)
      this.complexHistoryLocal = this.request.complexHistory
    }

    this.updateFullComplexHistory()
  },
  methods: {
    getColumns: function () {
      const user = this.$store.getters.getUser

      let columns = [
        {
          name: 'time',
          label: 'Дата/время изменения',
          align: 'left',
          field: 'time',
          sortable: false,
          format: formatTime
        },
        {
          name: 'name',
          label: 'Статус задания',
          align: 'left',
          field: 'name',
          sortable: false,
          style: 'min-width: 180px;'
        },
        {
          name: 'executor',
          label: 'Исполнитель',
          align: 'left',
          field: row => row.brigade || row.employee,
          sortable: false,
          style: 'min-width: 150px;'
        },
        {
          name: 'originSystem',
          label: 'Источник',
          align: 'left',
          field: row => row.originSystem ? row.originSystem.name : null,
          sortable: false,
          style: 'min-width: 150px;'
        },
        {
          name: 'fio',
          label: 'Пользователь',
          align: 'left',
          field: 'fio',
          sortable: false,
          style: 'min-width: 200px;'

        },
        {
          name: 'reason',
          label: 'Причина перехода',
          align: 'left',
          field: 'reason',
          sortable: false
        }
      ]

      if (user.restrictedAccess && user.employee && user.employee.external) {
        columns = columns.filter(column => column.name !== 'fio')
      }

      return columns
    },
    updateFullComplexHistory: function () {
      if (this.request.id) {
        this.loadingFullComplexHistory = true
        axiosGet({
          url: '/service/delta/request/complexHistory?id=' + this.request.id,
          onSuccess: (response) => {
            this.fullComplexHistory = response.data.result
            this.displayButton = this.fullComplexHistory.length > this.request.complexHistory.length
          },
          onFailure: 'Ошибка загрузки полной истории изменения статусов задания',
          msgTarget: this
        }).finally(() => {
          this.loadingFullComplexHistory = false
        })
      }
    },
    onFullComplexHistory: function () {
      if (!this.fullComplexHistoryDisplayed) {
        this.complexHistoryLocal = this.fullComplexHistory
        this.fullComplexHistoryDisplayed = true
      } else {
        this.complexHistoryLocal = this.request.complexHistory
        this.fullComplexHistoryDisplayed = false
      }
    },
    getTdStyle: function (col, row) {
      if (col.name === 'name') {
        if (row.id !== null) {
          if (this.taskStatesColors[row.id] === '#0000FF' || this.taskStatesColors[row.id] === '#000000' || this.taskStatesColors[row.id] === '#FF0000') {
            return 'font-weight: 1000 !important; color: white !important; background-color: ' + this.taskStatesColors[row.id] + ' !important; border-bottom: solid #e0e0e0 1px;'
          } else {
            return 'font-weight: 1000 !important; color: black !important; background-color: ' + this.taskStatesColors[row.id] + ' !important; border-bottom: solid #e0e0e0 1px;'
          }
        }
      }
    }
  }
}

